import { createContext } from "react";

export const MyBetsContext = createContext(null);
